import React, { Component } from 'react';
import NavBar from './components/NavBar';
import { msalConfig, tokenRequest, loginRequest, graphConfig } from './config';
import moment from 'moment';
import qs from 'qs';
import { UserAgentApplication } from 'msal';
import {myMSALObj,requestOptions,proxyUrl,tokenUrl,searchRequestOptions,detailsBaseUrl,esbRequestOptions,userGuidMap,restrictedEntities,environmentSetUp,environmentSelection} from './components/Configurations';
import {OAuth2} from 'fetch-mw-oauth2';
import $ from "jquery";
import {DataForPreview} from './components/DataPreview'

class Details extends Component{

    constructor(props){
        super(props)
        // console.log(this.props)
        this.state={
            keyword:"",
            guid:"",
            accessToken:sessionStorage.getItem("accessToken"),
            expiresOn:sessionStorage.getItem("expiresOn"),
            details:undefined,
            isPublic:false,
            isUnclassified:false,
            isConfidential:false,
            isStrictlyConfidential:false,
            piiYes:false,
            piiNo:false,
            isActive:false,
            isInactive:false,
            expert:"",
            owner:"",
            updatedBy:"",
            expertEmail:"",
            glossaryTerms:[],
            loadMoreClicked:false
        }
        this.handleLogOut = this.handleLogOut.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleRequestAccess = this.handleRequestAccess.bind(this);
        this.handleClickInfo = this.handleClickInfo.bind(this);
    }

    handleEdit(){
        // this.props.history.push({
        //     pathname:'/edit',
        //     search:"guid="+this.state.guid,
        //     state:{
        //         guid:this.state.guid,
        //         keyword:this.state.keyword
        //         }
        // })
        var guid = this.state.guid;
        var _editEntityUrl = environmentSetUp['editEntityDataUrl'][environmentSelection];
        _editEntityUrl = _editEntityUrl.toString().replace('{{guid}}',guid);
        window.open(_editEntityUrl, "_blank");
    }

    handleCreate(){
        this.props.history.push({
            pathname:'/create'
        })
    }

    handleLogOut(){
        sessionStorage.setItem('user','');
        sessionStorage.setItem('email','');
        sessionStorage.setItem('keyword','');
        sessionStorage.setItem('accessToken','');
        sessionStorage.setItem('expiresOn','');
        sessionStorage.setItem('role','');
        this.props.history.push('/logout');
        myMSALObj.logout();
        
      }

    handleRequestAccess(){
        window.open('mailto:'+this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Point_Of_Contact_Email']+"?subject=Request access of the data asset: "+this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+"&body=Description of the request:")
    }

    handleClickInfo(){

        this.setState({loadMoreClicked:!this.state.loadMoreClicked}) 
    //    $("#details-timestamp").css("visibility")==="hidden"?$("#details-timestamp").css({"visibility":"visible","opacity": 1}):$("#details-timestamp").css({"visibility":"hidden","opacity": 0,"transition": "visibility 0s, opacity 0.1s linear"})
        // $("#details-timestamp").toggle("active")
        // if($("#details-timestamp").css("display")==="block"){
        //     $("#details-timestamp").css("display","none")
        // }else{
        //     $("#details-timestamp").css("display","block")
        // }

    }

    componentWillMount(){

        // console.log(sessionStorage)
        
        if(qs.parse(this.props.location.search)['?guid'] !== undefined){
            // console.log("found param")
            this.setState({
                guid:qs.parse(this.props.location.search)['?guid']
            },()=>{
                // console.log("state set")
                sessionStorage.setItem('guid',this.state.guid)
            })
        }else{
            sessionStorage.setItem('guid',this.state.guid)
        }

        if(this.props.location.state!==undefined){
            if(this.props.location.state.keyword!==undefined ){
                this.setState({keyword:this.props.location.state.keyword})
            }
        }
        

    }

    async componentDidMount(){

        if (myMSALObj.getAccount() === null){
            myMSALObj.loginRedirect(loginRequest);
          }else{
            sessionStorage.setItem('user',myMSALObj.getAccount().name);
            sessionStorage.setItem('email',myMSALObj.getAccount().userName);
        }

        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            console.log('token is bad.')
            console.log(environmentSetUp["purviewAccessToken"][environmentSelection]);
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp["purviewAccessToken"][environmentSelection])
            const data = await res.json()
            var currentDateTime = new Date();
            console.log('the new code');
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
                
                accessToken:data.access_token,
                expiresOn:new Date(currentDateTime).getTime()/1000
                // accessToken:data.accessToken,
                // expiresOn:new Date(data["expiresOn"]).getTime()/1000
            },()=>{
                sessionStorage.setItem('accessToken',this.state.accessToken);
                sessionStorage.setItem('expiresOn',this.state.expiresOn);
                fetch(environmentSetUp["detailBaseUrl"][environmentSelection] +this.state.guid,{
                    method: 'GET',
                    headers:{
                        'Authorization':'Bearer ' + this.state.accessToken,
                        'Content-Type': 'application/json'
                    }}).then(res=>res.json())
                .then(data=>this.setState({
                    details:data.entity
                },()=>{

                    console.log(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Dataset_Owner'])
                    if(this.state.details.relationshipAttributes.meanings[0]!==undefined){
                        this.state.details.relationshipAttributes.meanings.map(item=>(
                            this.setState(prevState =>{
                                prevState.glossaryTerms.push({"guid":item.guid,"text":item.displayText})
                            })
                        ))
                    }else{
                        this.state.glossaryTerms.push({"guid":"","text":"No glossary terms yet"})
                    }

                    this.setState({
                        owner:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Owner[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Owner[0]["id"]]["name"],
                        expert:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Expert[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Expert[0]["id"]]["name"] ,
                        expertEmail:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Expert[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Expert[0]["id"]]["email"] 
                    })

                    if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Updated_By']===""){
                        this.setState({updatedBy:"N/A"})
                    }else{
                        this.setState({updatedBy:this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Updated_By']})
                    }

                    if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"){
                        this.setState({piiYes:true})
                    }else{
                        this.setState({piiNo:true})
                    }

                    if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Status']==="Active"){
                        this.setState({isActive:true})
                    }else if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Status']==="Inactive"){
                        this.setState({isInactive:true})
                    }

                    if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']==="PUBLIC"){
                        this.setState({isPublic:true})
                    }else if (this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']==="CONFIDENTIAL"){
                        this.setState({isConfidential:true})
                    }else if (this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']==="STRICTLY CONFIDENTIAL"){
                        this.setState({isStrictlyConfidential:true})
                    }else{
                        this.setState({isUnclassified:true})
                    }

                }))
            })

            
        }else{
            // console.log('token is good.')
            const response = await fetch(environmentSetUp["detailBaseUrl"][environmentSelection]+this.state.guid,{
                method: 'GET',
                headers:{
                    'Authorization':'Bearer ' + this.state.accessToken,
                    'Content-Type': 'application/json'
                }})
            const data = await response.json()
            this.setState({
                details:data.entity
                },()=>{

                    // console.log(this.state.details.attributes.Dataset_Owner)
                    if(this.state.details.relationshipAttributes.meanings[0]!==undefined){
                        this.state.details.relationshipAttributes.meanings.map(item=>(
                            this.setState(prevState =>{
                                prevState.glossaryTerms.push({"guid":item.guid,"text":item.displayText})
                            })
                        ))
                    }else{
                        this.state.glossaryTerms.push({"guid":"","text":"No glossary terms yet"})
                    }

                    
                    this.setState({
                        owner:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Owner[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Owner[0]["id"]]["name"],
                        expert:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Expert[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Expert[0]["id"]]["name"] ,
                        expertEmail:this.state.details.contacts===undefined||userGuidMap[this.state.details.contacts.Expert[0]["id"]]===undefined?"N/A":userGuidMap[this.state.details.contacts.Expert[0]["id"]]["email"] 
                    })

                    if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Updated_By']===""){
                        this.setState({updatedBy:"N/A"})
                    }else{
                        this.setState({updatedBy:this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Updated_By']})
                    }

                    if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"){
                        this.setState({piiYes:true})
                    }else{
                        this.setState({piiNo:true})
                    }

                    if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Status']==="Active"){
                        this.setState({isActive:true})
                    }else if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Status']==="Inactive"){
                        this.setState({isInactive:true})
                    }

                    if(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']==="PUBLIC"){
                        this.setState({isPublic:true})
                    }else if (this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']==="CONFIDENTIAL"){
                        this.setState({isConfidential:true})
                    }else if (this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']==="STRICTLY CONFIDENTIAL"){
                        this.setState({isStrictlyConfidential:true})
                    }else{
                        this.setState({isUnclassified:true})
                    }
                
                } )
        }
    }


    render(){
       console.log(this.state) 
       if(this.state.details===undefined){
           return(
            <div className="spinner text-center ">
                <div className="spinner-border align-middle" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
           )
       }else{
            var dataPreviewTable;
            var imageIndicator;
            try{
                require('../public/images/'+this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.PNG')
                imageIndicator = true
            }
            catch(e){
                imageIndicator = false
            }
            if(DataForPreview["allDocs"].includes(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['QualifiedName'])){
                dataPreviewTable=(
                    <table className="table table-hover table-sm rounded shadow">
                        <thead>
                            <tr>
                                {DataForPreview[this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['QualifiedName']]["headers"].map((item, index)=>{
                                    return(
                                        <th key={index} scope="col"><h6 key={item} className="font-weight-bold small" >{item}</h6></th>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                                {DataForPreview[this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['QualifiedName']]["data"].map((item, index)=>{
                                    return(
                                        <tr key={index}>
                                            {DataForPreview[this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['QualifiedName']]["headers"].map((i,index)=>{
                                                return(
                                                    <td key={index} className="text-secondary" ><p className="small text-secondary mb-0" >{item[i]}</p></td>
                                                )
                                            })}
                                        </tr>
                                    )
                                })}
                        </tbody>
                    </table>
                    )
                
            }
            else if(imageIndicator===true){
                dataPreviewTable=<img className="previewScreenshot rounded shadow mt-1" src={process.env.PUBLIC_URL+'/images/'+this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.PNG'} alt="screenshot"></img>
            }
            else{
                dataPreviewTable=<p className="font-weight-bold text-secondary" >Sorry the dataset does not have any preview.</p>
            }

        return(
            <React.Fragment>
                <NavBar handleLogOut={this.handleLogOut}  handleCreate={this.handleCreate}/>
                <nav aria-label="breadcrumb w-100" className="mb-4">
                     <ol className="breadcrumb-content breadcrumb bg-light w-100 mr-0 float-left">
                         <li className="breadcrumb-item small"><a href="/">Home</a></li>
                         <li className="breadcrumb-item small"><a href={this.state.keyword===""?"/results?keyword=":"/results?keyword="+this.state.keyword}>List</a></li>
                         <li className="breadcrumb-item active small">Details</li>
                     </ol>
                </nav>
                <div className="details-main">
                    <div className="px-3 mx-0">
                        <h1 className="px-5 pb-1 col-9 details-title font-weight-bold float-left">
                            {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                        </h1>  
                                
                        <p className="px-5 pt-1 pb-2 text-secondary w-75 detail-description">
                            {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"No description has been added to the current data asset.    ":this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Description']+"    "}
                            <a href="#details-info" data-toggle="collapse">
                                <i onClick={this.handleClickInfo} className= {this.state.loadMoreClicked===false?"fas fa-plus-circle fa-sm text-secondary details-info-button":"fas fa-minus-circle fa-sm text-secondary details-info-button"} />
                            </a>
                        </p>
                        <div className="collapse mx-5 w-50" id="details-info" >
                            
                            <div className="details-timestamp  bg-secondary  border-0 rounded shadow-lg p-3">
                                <p className="m-0 text-white">
                                    Registerd on: {" " + moment.utc(this.state.details.createTime).local().toLocaleString()}
                                </p>
                                <p className="m-0 text-white">
                                    Modified on: {" " + moment.utc(this.state.details.updateTime).local().toLocaleString()}
                                </p>
                                <p className="m-0 text-white">
                                    Updated by: {this.state.updatedBy}
                                </p>
                            </div>                            
                            <button type="button" 
                                    className="btn btn-outline-success btn-sm float-left details-button shadow font-weight-bold my-3" 
                                    onClick={this.handleEdit}
                                    style={{visibility:sessionStorage.getItem("role")==="curator"?"visible":"hidden"}} >Edit Details</button>
                        </div> 
                        
                        
                    </div>
                      
                    <div className="container-fluid row results-main mx-0 pt-1"> 

                        <div className="col-9 px-0"> 
                            
                            <ul className="nav nav-tabs mb-3 px-5">
                                <li className="nav-item">
                                    <a className="nav-link active content-tab" data-toggle="tab" id="primary-tab" href="#primary-content">Details</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link content-tab"  data-toggle="tab" id="preview-tab" href="#preview-content" >Data</a>
                                </li>
                            </ul>                    
                            <div className="tab-content">
                                
                                <div id="primary-content" className="tab-pane fade show active px-3">
                                    
                                    <div className="w-50 float-left mx-0 mb-2 mt-2 py-0 px-3">
                                        
                                        <div>
                                            <p className="px-3 pt-0 mb-0 text-uppercase text-secondary font-weight-bold" title="Abbreviation of the Entitiy/Department Name">
                                            entity
                                            </p>
                                            <p className="px-3 mb-0">
                                                {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+" - "+this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Entity']}
                                            </p>
                                            <p className="px-3 font-italic">
                                                {"Organization: "+this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Organization_ID']+" - "+this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                                            </p>
                                        </div>
{/*                                         
                                        <div>
                                            <p className="px-3 pt-1 mb-0 text-uppercase text-secondary font-weight-bold">
                                            organization
                                            </p>
                                            <p className="px-3">
                                                {this.state.details.attributes.Organization_ID+" - "+this.state.details.attributes.Organization}
                                            </p>
                                        </div>
                                        
                                         */}

                                        
                                            {this.state.details.attributes.Status===""?<React.Fragment></React.Fragment>:
                                                <div className="px-3">
                                                    <p className="pt-2 mb-0 text-uppercase text-secondary font-weight-bold" title="Status of data">
                                                    status
                                                    </p>
                                                    <p className="px-0 mb-1">
                                                        {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Status']}
                                                    </p>
                                                    {/* <div className="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" id="isActive-radio" name="isActive" 
                                                                className="custom-control-input"
                                                                disabled={!this.state.isActive}
                                                                checked={this.state.isActive} />
                                                        <label className="custom-control-label small">Active</label>
                                                    </div>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" id="isInactive-radio" name="isInactive" 
                                                                className="custom-control-input"
                                                                disabled={!this.state.isInactive}
                                                                checked={this.state.isInactive} />
                                                        <label className="custom-control-label small">Inactive</label>
                                                    </div> */}
                                                </div> }
                                            
                                            
                                            
                                        {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Function']===""?<div></div>:<div>
                                            <p className="px-3 pt-3 mb-1 text-uppercase text-secondary font-weight-bold">
                                            function
                                            </p>
                                            <p className="px-3 mb-1">
                                                {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Function']}
                                            </p>
                                            {/* <form>
                                                <fieldset disabled>
                                                <div className="form-group px-3">
                                                        <select id="disabledSelect" className="form-control form-control-sm">
                                                            <option >{this.state.details.attributes.Function}</option>
                                                        </select>
                                                    </div> 
                                                </fieldset>
                                            </form> */}
                                        </div>}

                                        

                                        <div>
                                            <p className="px-3 pt-1 mb-1 text-uppercase text-secondary font-weight-bold" title="Language data set is available in">
                                            language
                                            </p>
                                            <p className="px-3 mb-1">
                                                {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Language']}
                                            </p>
                                            {/* <form>
                                                <fieldset disabled>
                                                    <div className="form-group px-3">
                                                        <select id="disabledSelect" className="form-control form-control-sm">
                                                            <option >{this.state.details.attributes.Language}</option>
                                                        </select>
                                                    </div> 
                                                </fieldset>
                                            </form> */}
                                        </div>

                                        {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']===""?<div></div>:<div>
                                            <p className="px-3 pt-1 mb-0 text-uppercase text-secondary font-weight-bold" title="Dataset source">
                                            back end
                                            </p>
                                            <p className="px-3 mb-1">
                                                {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}
                                            </p>
                                        </div>}

                                        <div>
                                            <p className="px-3 pt-2 mb-0 text-uppercase text-secondary font-weight-bold w-100" title="Dataset source">
                                            glossary terms
                                            </p>
                                            <div className="pl-2">
                                            {
                                            this.state.glossaryTerms.map(item=>{
                                                return (
                                                <p key={item.guid.toString()} id={item.guid} className="details-glossary-terms px-3 py-1 my-2 mx-2 rounded shadow-sm float-left" >{item.text}</p>
                                                )
                                            })
                                            }
                                            </div>
                                            
                                        </div>

                                        {/* <div className="m-2">
                                        <p className="text-uppercase pl-2 pt-1 pb-1 mb-0 text-light font-weight-bold">Glossary terms  <i title="Glossary terms are the terms that can be associated with the data asset, and allowing user to have better understanding of it." className="fas fa-info-circle fa-sm"/></p>
                                        {
                                            this.state.glossaryTerms.map(item=>{
                                                return (
                                                <p id={item.guid} className="p-1 mx-2 pt-1 btn-light btn-sm border-0 shadow font-weight-bold text-center text-secondary" >{item.text}</p>
                                                )
                                            })
                                        }
                                        </div> */}
                                        
                                    
                                    </div>
                                    
                                    <div className="w-50 float-right mx-0 mb-2 mt-2 py-0 px-3">
                                        
                                        <div>
                                            <p className="px-3 pt-0 mb-0 text-uppercase text-secondary font-weight-bold" title="ORIGINAL DATA SET TITLE/NAME">
                                            technical name
                                            </p>
                                            <p className="px-3 mb-1 ">
                                            {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Technical_Name']}
                                            </p>
                                        </div>
                                        
                                        <div>
                                            <p className="px-3 pt-2 mb-0 text-uppercase text-secondary font-weight-bold" title="Personal Identifiable Information">
                                            PII
                                            </p>
                                            <div className="px-3 mb-1">
                                                <div className="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="piiYes-radio" name="piiYes" 
                                                            className="custom-control-input"
                                                            disabled={!this.state.piiYes}
                                                            checked={this.state.piiYes} />
                                                    <label className="custom-control-label small">YES</label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="piiNo-radio" name="piiNo" 
                                                            className="custom-control-input"
                                                            disabled={!this.state.piiNo}
                                                            checked={this.state.piiNo} />
                                                    <label className="custom-control-label small">NO</label>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div>
                                            <p className="px-3 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="Security Classification Level">
                                            sensitivity level
                                            </p>
                                            {<p className="px-3 mb-1">The data asset is <strong className="text-secondary" >{this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']?.toLowerCase()}</strong></p>}
                                            {/* <div className="px-3 mb-1">
                                                <div className="custom-control custom-radio">
                                                    <input type="radio" id="isPublic-radio" name="isPublic" 
                                                        className="custom-control-input" 
                                                        disabled={!this.state.isPublic} 
                                                        checked={this.state.isPublic}  />
                                                    <label className="custom-control-label small" for="isPublic-radio">PUBLIC</label>
                                                </div>
                                                <div className="custom-control custom-radio">
                                                    <input type="radio" id="isUnclassified-radio" name="isUnclassified" 
                                                        className="custom-control-input" 
                                                        disabled={!this.state.isUnclassified}
                                                        checked={this.state.isUnclassified} />
                                                    <label className="custom-control-label small" for="isUnclassified-radio">UNCLASSIFIED</label>
                                                </div>
                                                <div className="custom-control custom-radio">
                                                    <input type="radio" id="isConfidential-radio" name="isConfidential" 
                                                        className="custom-control-input" 
                                                        disabled={!this.state.isConfidential}
                                                        checked={this.state.isConfidential} />
                                                    <label className="custom-control-label small" for="isConfidential-radio">CONFIDENTIAL</label>
                                                </div>
                                                <div className="custom-control custom-radio">
                                                    <input type="radio" id="isStrictlyConfidential-radio" name="isStrictlyConfidential" 
                                                        className="custom-control-input" 
                                                        disabled={!this.state.isStrictlyConfidential}
                                                        checked={this.state.isStrictlyConfidential} />
                                                    <label className="custom-control-label small" for="isStrictlyConfidential-radio">STRICTLY CONFIDENTIAL</label>
                                                </div>
                                            </div> */}
                                        </div>

                                        <div>
                                            <p className="px-3 pt-2 mb-0 text-uppercase text-secondary font-weight-bold"  title="Earliest content date inside the dataset to the latest content date inside the dataset" >
                                            date range
                                            </p>
                                            <p className="px-3 mb-1" >
                                           
                                           
                                            {/* {moment.unix(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Start_Date']/1000).format('dddd, Do MMMM YYYY') + " -- "+ (this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Close_Date']===0?"Present":moment.unix(this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Close_Date']/1000).format('dddd, Do MMMM YYYY'))} */}
                                            {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Start_Date'] + " -- "+ (this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Close_Date']===0?"Present":this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Close_Date'])}
                                           
                                           
                                           
                                           
                                            </p>
                                        </div>


                                        {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Frequency']===""?<div></div>:<div>
                                            <p className="px-3 pt-1 mb-1 text-uppercase text-secondary font-weight-bold" title="How often is the data refreshed or updated?">
                                            refresh frequency
                                            </p>
                                            <p className="px-3 mb-1">
                                                {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Frequency']}
                                            </p>
                                            {/* <form>
                                                <fieldset disabled>
                                                    <div className="form-group px-3">
                                                        <select id="disabledSelect" className="form-control form-control-sm">
                                                            <option >{this.state.details.attributes.Frequency}</option>
                                                        </select>
                                                    </div> 
                                                </fieldset>
                                            </form> */}
                                        </div>}
                                        

                                        
                                    
                                    </div>
                                
                                </div> 
                                                        
                                <div id="preview-content" className="tab-pane fade">
                                
                                    <div>
                                        <p className="px-5 pt-2 mb-1 text-uppercase text-secondary font-weight-bold" title="URL">
                                        link to data
                                        </p>
                                        <p className="px-5">
                                            {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Link_To_Data'] === ""
                                            ?"N/A"
                                            :<a target="_blank" rel="noopener noreferrer" href={this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Link_To_Data']}>{this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Link_To_Data']}</a>}
                                        </p>
                                    </div>
                                    {this.state.details['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']?.toLowerCase()!=="public"?<button type="button" className="btn btn-outline-success btn-sm mt-2 mb-3 mx-5 details-button shadow-sm font-weight-bold"
                                        onClick={this.handleRequestAccess}>Request Access</button>:<button type="button" className="d-none btn btn-outline-success btn-sm mt-2 mb-3 mx-5 details-button shadow-sm font-weight-bold"
                                        onClick={this.handleRequestAccess}>Request Access</button>}
                                    
                                    <p className="pt-2 mb-1 ml-5 text-uppercase text-secondary font-weight-bold" title="URL">
                                        data preview
                                    </p>
                                    <div className="data-preview ml-5 pt-0">
                                        {dataPreviewTable}
                                    </div>
                                </div>

                            </div>
                        
                        </div>
                        
                        <div className="col-1"></div>
                        <div className="col-2 ">
                            <br></br>
                            <div className="card mx-0 px-0 pt-0 mt-4 border-0 shadow-lg rounded details-contact-card mb-4">                               
                                <div className="m-2">
                                <p className="text-uppercase pl-2 pt-2 mb-0 text-light font-weight-bold">Expert <i title="Expert is the entity who is responsible for maintaining the data asset." className="fas fa-info-circle fa-sm"/></p>
                                <p className="pl-2 pt-1 mx-2 btn-light btn-sm border-0 shadow font-weight-bold text-center text-secondary">{this.state.expert}</p>
                                </div>
                                <div className="m-2">
                                <p className="text-uppercase pl-2 pt-2 mb-0 text-light font-weight-bold">Owner <i title="Owner is the entity that has the ownership of the data asset." className="fas fa-info-circle fa-sm"/></p>
                                <p className="pl-2 pt-1 mx-2 btn-light btn-sm border-0 shadow font-weight-bold text-center text-secondary">{this.state.owner}</p>
                                </div>                                        
                            </div>
                        </div>
                    </div>
                </div>
                
            </React.Fragment>
        )
       }
      
   }
}

export default Details

